const state = {
  dashboard: {
    dateRange: {}
  },
  reports: {
    dateRange: { startDate: new Date().setMonth(new Date().getMonth() - 1), endDate: new Date() }
  }
};

const getters = {
  dashboardDateRange: (state) => state.dashboard.dateRange,
  reportsDateRange: (state) => state.reports.dateRange
};

const mutations = {
  SET_DASHBOARD_DATE_RANGE(state, range) {
    state.dashboard.dateRange = range;
  },
  SET_REPORTS_DATE_RANGE(state, range) {
    state.reports.dateRange = range;
  }
};

export default {
  state,
  getters,
  mutations
};
